module.exports = __webpack_public_path__ + "img/selected0-min.a7cf625b.png";